export const I18N_KEY = 'i18n';
